import { humanize } from 'shared/functions';

const ratingTypeToString = {
  PUBLIC: 'Public',
  SUBSCRIPTION: 'Subscription',
  ON_REQUEST: 'Subscription',
  ON_DEMAND_OPEN_SUBSCRIPTION: 'Subscription',
  RESTRICTED_SUBSCRIPTION: 'Restricted Subscription',
  PRIVATE: 'Private',
};

export const parseRatingType = (rating) =>
  rating ? ratingTypeToString[rating] || humanize(rating) : '';
